import Vue from 'vue'

Vue.filter('price', (value) => {
  if (!value) return ''
  return '$ ' + new Intl.NumberFormat('es-CL').format(parseInt(value))
})



// WEBPACK FOOTER //
// ./src/filters/price.js